import Vue from 'vue';

// const components = [
//     require.context('../components/blocks', false, /\.vue$/),
//     require.context('../components/theme', false, /\.vue$/),
//     require.context('../components/widgets', false, /\.vue$/),
// ];
//
// components.forEach((requireComponent) => {
//     requireComponent.keys().forEach((fileName) => {
//         const componentConfig = requireComponent(fileName);
//         Vue.component(fileName.replace(/^\.\/(.*)\.\w+$/, '$1'), componentConfig.default || componentConfig)
//     });
// });

Vue.component('DfApp', () => import('../components/blocks/DfApp'));
Vue.component('DfAwait', () => import('../components/blocks/DfAwait'));
Vue.component('DfCoach', () => import('../components/blocks/DfCoach'));
Vue.component('DfConfirm', () => import('../components/blocks/DfConfirm'));
Vue.component('DfAdminForm', () => import('../components/blocks/DfAdminForm'));
Vue.component('DfAdminList', () => import('../components/blocks/DfAdminList'));

Vue.component('BeAlert', () => import('../components/theme/BeAlert'));
Vue.component('BeCard', () => import('../components/theme/BeCard'));
Vue.component('BeFormGroup', () => import('../components/theme/BeFormGroup'));
Vue.component('BeLeftSidebar', () => import('../components/theme/BeLeftSidebar'));
Vue.component('BeLoading', () => import('../components/theme/BeLoading'));
Vue.component('BeModal', () => import('../components/theme/BeModal'));
Vue.component('BeNotification', () => import('../components/theme/BeNotification'));
Vue.component('BeNotifications', () => import('../components/theme/BeNotifications'));
Vue.component('BeProgress', () => import('../components/theme/BeProgress'));
Vue.component('BeScrollTop', () => import('../components/theme/BeScrollTop'));
Vue.component('BeSpinner', () => import('../components/theme/BeSpinner'));
Vue.component('BeSplashScreen', () => import('../components/theme/BeSplashScreen'));
Vue.component('BeTabs', () => import('../components/theme/BeTabs'));
Vue.component('BeTopHeader', () => import('../components/theme/BeTopHeader'));
Vue.component('BeWizard', () => import('../components/theme/BeWizard'));

Vue.component('ImageUpload', () => import('../components/widgets/ImageUpload'));
Vue.component('MultiSelect', () => import('../components/widgets/MultiSelect'));
Vue.component('RadioCheckbox', () => import('../components/widgets/RadioCheckbox'));
Vue.component('RangeSlider', () => import('../components/widgets/RangeSlider'));
Vue.component('SelectList', () => import('../components/widgets/SelectList'));
Vue.component('SelectMenu', () => import('../components/widgets/SelectMenu'));
Vue.component('SubmitButton', () => import('../components/widgets/SubmitButton'));
Vue.component('TagList', () => import('../components/widgets/TagList'));
Vue.component('TextArea', () => import('../components/widgets/TextArea'));
Vue.component('TextField', () => import('../components/widgets/TextField'));
Vue.component('Validation', () => import('../components/widgets/Validation'));

Vue.component('Avatar', () => import('@lossendae/vue-avatar'));
